// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question-summary {\n  margin-bottom: 1em;\n}\n.question-summary .prompt,\n.question-summary .stats {\n  display: inline-block;\n}\n.question-summary .stats {\n  float: right;\n}\n", ""]);
// Exports
module.exports = exports;
